import { defineComponent as _defineComponent } from 'vue'
import {
  ChildUpdater,
  ParamConfiguration,
  Params,
  ParamValue,
} from '@/models/enums/WidgetEnum';
import WidgetDefinition from '@/models/Charts/widgetDefinition';
import { computed, defineAsyncComponent, inject, onMounted, ref } from 'vue';
import { isNil } from '@/utils/misc';


/** @deprecated THIS COMPONENT IS FROZEN **/
const __default__ = {};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'ThreeDotParamEntry',
  props: {
    params: null,
    paramValues: null,
    position: { default: 'is-right' }
  },
  emits: ["update"],
  setup(__props: any, { emit }: { emit: ((e: 'update', value: { [key: string]: any }) => void), expose: any, slots: any, attrs: any }) {

const props = __props as { params: Params, paramValues: { [key: string]: any }, position: string };

const NumberParam = defineAsyncComponent(
  () => import('./threeDotParams/NumberParam.vue'),
);
const RadioParam = defineAsyncComponent(
  () => import('./threeDotParams/RadioParam.vue'),
);
const ListParam = defineAsyncComponent(
  () => import('./threeDotParams/ListParam.vue'),
);
const SliderParam = defineAsyncComponent(
  () => import('./threeDotParams/SliderParam.vue'),
);
const AsyncThreeDotParamEntry = defineAsyncComponent(
  () => import('./ThreeDotParamEntry.vue'),
);





const widgetDefinition = inject<WidgetDefinition>('widgetDefinition')!;

const children = ref<Record<string, Record<string, ParamConfiguration>>>({});
// Without this flag, weird race conditions can occur, where the child parameter's onMounted
// finishes before the parent's.
const areChildrenLoading = ref(false);

onMounted(async () => {
  areChildrenLoading.value = true;
  const childrenConfiguration: Record<
    string,
    Record<string, ParamConfiguration>
  > = {};
  for (const [paramName, paramConfig] of parameters.value) {
    if (!paramConfig.children) {
      continue;
    }
    const childrenParamConfigs = await getChildrenParamConfigurations(
      paramConfig.children,
      widgetDefinition.paramValues[paramName] ?? paramConfig.defaultValue!,
    );
    childrenConfiguration[paramName] = childrenParamConfigs;
  }
  children.value = childrenConfiguration;
  areChildrenLoading.value = false;
});

async function getChildrenParamConfigurations(
  childrenUpdater: Record<string, ChildUpdater<any>>,
  parentParamValue: ParamValue,
): Promise<Params> {
  const childrenParamConfigs: Record<string, ParamConfiguration> = {};
  for (const [childName, childParamConfig] of Object.entries(childrenUpdater)) {
    childrenParamConfigs[childName] = await childParamConfig(
      parentParamValue,
      widgetDefinition,
    );
  }
  return childrenParamConfigs;
}

async function onUpdate(
  paramName: string,
  paramConfig: ParamConfiguration,
  param: { [key: string]: any },
) {
  computedParamValues.value = param;
  if (!isNil(paramConfig.children)) {
    const childrenParamConfigs = await getChildrenParamConfigurations(
      paramConfig.children,
      param[paramName],
    );
    children.value = {
      ...children.value,
      [paramName]: childrenParamConfigs,
    };
  }
}

function onChildUpdate(param: { [key: string]: any }) {
  computedParamValues.value = {
    ...computedParamValues.value,
    ...param,
  };
}

function getComponentForParamType(paramInfo: ParamConfiguration) {
  switch (paramInfo.type) {
    case 'number':
      return NumberParam;
    case 'radio':
      return RadioParam;
    case 'list':
      return ListParam;
    case 'slider':
      return SliderParam;
  }
}

const parameters = computed(() => Object.entries(props.params ?? {}));

const computedParamValues = computed({
  get() {
    return props.paramValues;
  },
  set(newValue) {
    emit('update', newValue);
  },
});

return { __sfc: true,NumberParam, RadioParam, ListParam, SliderParam, AsyncThreeDotParamEntry, props, emit, widgetDefinition, children, areChildrenLoading, getChildrenParamConfigurations, onUpdate, onChildUpdate, getComponentForParamType, parameters, computedParamValues, isNil }
}

})